<template>
  <div id="programacion-titulo-toolbar">
    <v-toolbar
      class="mb-2"
      flat>
      <v-toolbar-title
        class="display-1">
        Oficios de Autorización
      </v-toolbar-title>
    </v-toolbar>
  </div>
</template>

<script>
export default {
  name: 'ProgramacionTituloToolBar',

};
</script>

<style>

</style>
